export default class QuestionTranslation {

    constructor(text, language){
        this.text = text;
        this.language = language;
    }

    getText(){
        return this.text;
    }

    getLanguage(){
        return this.language;
    }
    
    setText(text){
        this.text = text;
    }

    setLanguage(language){
        this.language = language;
    }
}